export const DEFAULT_SNACKBAR_TIME = 6000;

export const DEFAULT_SNACKBAR = {
  type: "",
  open: false,
  message: "",
}

export const getError = (e) => {
  try {
    return e.response.data.message;
  } catch (e) {
    return "Something went wrong. Try again.";
  }
}

export const defaultData = (fields) => {
  const o = {};
  for (const k of fields) {
    o[k] = "";
  }

  return o;
}
